import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class CreditorMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.creditor.creditorMapperError"));

        Object.setPrototypeOf(this, CreditorMapperError.prototype);
    }
}